import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitCommitmentStatuses = createSelector(
  [selectFinancialCockpitState],
  ({ commitmentStatuses }) => commitmentStatuses
)
